import { defineAppConfig } from "#imports";
import { version, name } from "../package.json";

export default defineAppConfig({
  appVersion: version,
  appName: name,
});
